import React from 'react';
import Timeline from '../../components/Timeline/Timeline';
import FontAwesome from 'react-fontawesome';
import Button from '../../components/Button/Button';
import { manageMyAccount } from '../../settings/links.json';

const openInNewTab = url => {
    window.open(url, '_blank');
};

const CreateAccount = ({ deploy }) => {
    return (
        <Timeline
            heading="create an online account"
            icon={
                <FontAwesome
                    className="primary-yellow con md image_center icon15"
                    name="user"
                    datacy="user"
                    size="2x"
                />
            }>
            As a Safeco customer, you have the flexibility and convenience of managing your account
            online.
            <br />
            <br />
            Creating an account only takes a few minutes and allows you to pay your bill, update
            your personal information, print ID cards and file a claim, just to name a few of the
            benefits.
            <div>
                <Button
                    heapAttribute="create-account-inline-button"
                    text="Create account"
                    type="secondary"
                    onClick={() => openInNewTab(deploy.env ? manageMyAccount[deploy.env] : '')}
                    datacy="create-account-secondary"
                />
            </div>
        </Timeline>
    );
};

export default CreateAccount;



// WEBPACK FOOTER //
// ./src/containers/CreateAccount/CreateAccount.jsx